import StockList from './StockList';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function StockManagement() {
    const { t } = useTranslation();

    return (
        <>
            <Typography variant="h5" fontWeight="bold" mb={2}>
                {t('stockManagement.title')}
            </Typography>
            <StockList />
        </>
    )
}
